// extracted by mini-css-extract-plugin
export default {"errorDiv":"FormError--errorDiv---LSu5","error":"FormError--error--SFia-","errorIcon":"FormError--errorIcon--4RAX2","errorTextIcon":"FormError--errorTextIcon--bJ0ZF"};